import { render, staticRenderFns } from "./BillType.vue?vue&type=template&id=054d347c&scoped=true&"
import script from "./BillType.vue?vue&type=script&lang=js&"
export * from "./BillType.vue?vue&type=script&lang=js&"
import style0 from "./BillType.vue?vue&type=style&index=0&id=054d347c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d347c",
  null
  
)

export default component.exports